import { Formik, Form as FormikForm } from "formik";
import moment from "moment";
import { FC, useContext, useEffect, useState } from "react";
import { Accordion, Button, Form, Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { AppContext } from "../../../appContext/AppContext";
import { TTopicDetails } from "../../../quan-ly-de-tai/de-tai/models/TopicModel";
import { objectToFormData } from "../../../utils/AppFunction";
import { ACCEPT_FILE_TYPE, CODE, MEMBER_TYPE, ORG_TYPE } from "../../../utils/Constant";
import { handleDownloadFile } from "../../../utils/ServicesUtils";
import {
  TExecutiveOrganization,
  TImplementOfficer,
  TMainCoordinatingOrganization,
  TMainResearcher,
  TMyTopic,
  TTopicOutline,
  TTopicSecretary
} from "../../models/MyTopicModel";
import { getOulineFile, updateTopicOutline } from "../../services/services";

type IProps = {
  topicInfo: TTopicDetails;
  executiveOrganization: TExecutiveOrganization;
  mainResearcher: TMainResearcher;
  topicSecretary: TTopicSecretary;
  implementOfficerList: TImplementOfficer[];
  mainCoordinatingOrganizationList: TMainCoordinatingOrganization[];
  formRef: React.MutableRefObject<any>;
  isEdit: boolean;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
}
const TabOutline: FC<IProps> = (props) => {
  const { topicInfo, executiveOrganization, mainResearcher, topicSecretary, implementOfficerList, mainCoordinatingOrganizationList, formRef, isEdit, setIsEdit } = props;

  const location = useLocation();
  const { setIsLoading } = useContext(AppContext);
  const state = location.state as { show?: boolean; data?: TMyTopic };

  const [officerList, setOfficerList] = useState<TImplementOfficer[]>([]);
  const [organizationList, setOrganizationList] = useState<TMainCoordinatingOrganization[]>([]);
  const [outlineFiles, setOutlineFiles] = useState<any[]>([]);
  const [openEditFile, setOpenEditFile] = useState<boolean>(false);
  const [newFile, setNewFile] = useState<File | null>(null);

  let validationSchema = Yup.object({});

  useEffect(() => {
    let topicId = topicInfo?.id;
    if (!topicId) return;
    getOulineFile(topicId).then((res) => {
      if (res?.data?.code === CODE.SUCCESS) {
        let files = res?.data?.data || [];
        setOutlineFiles(files);
      }
    })
  }, [topicInfo?.id])

  useEffect(() => {
    setOrganizationList(mainCoordinatingOrganizationList);
    setOfficerList(implementOfficerList);
  }, [mainCoordinatingOrganizationList, implementOfficerList]);

  const handleChangeFile = async (e: any) => {
    let file = e?.target?.files?.[0];
    if (!file) return;
    if (![ACCEPT_FILE_TYPE.DOC, ACCEPT_FILE_TYPE.DOCX, ACCEPT_FILE_TYPE.PDF].includes(file.type)) {
      toast.warning("Chi được phép tải lên tệp tin nên định dạng .doc, .docx hoặc .pdf");
      e.target.value = '';
    } else {
      setNewFile(file);
    }
  };

  const handleFormSubmit = async (values: TTopicOutline) => {
    const newOfficerList = officerList.map((officer, index) => {
      return {
        ...officer,
        scientificTitle: officer.scientificTitle,
        officeCurrently: officer.officeCurrently,
        typeId: officer.typeId,
        academicRank: officer.academicRank,
        degree: officer.degree,
        name: officer.name
      }
    })
    let dataTopicOutline = {
      name: values.name ?? "",
      code: values.code ?? "",
      numMonths: (values.startDate && values.endDate) ? (moment(values.endDate).month() - moment(values.startDate).month()) + 1 : 0,
      startDate: values.startDate ? moment(values.startDate).startOf("month").format("YYYY-MM-DD") : "",
      endDate: values.endDate ? moment(values.endDate).endOf("month").format("YYYY-MM-DD") : "",
      manageLevel: values.manageLevel ?? "",
      budgetTotal: (values.budgetFromGovernment || 0) + (values.budgetFromOther || 0),
      budgetFromGovernment: values.budgetFromGovernment || 0,
      budgetFromOther: values.budgetFromOther || 0,
      isPaymentEntire: values.isPaymentEntire || false,
      isPaymentPart: values.isPaymentPart || false,
      paymentPieceWork: values.paymentPieceWork || 0,
      paymentNotPieceWork: values.paymentNotPieceWork || 0,
      isPartProgram: values.isPartProgram || false,
      programName: values.programName ?? "",
      programCode: values.programCode ?? "",
      isScience: values.isScience || false,
      isSingle: values.isSingle || false,
      isOther: values.isOther || false,
      members: [{...mainResearcher, typeId: MEMBER_TYPE.CHU_NHIEM_DE_TAI}, {...topicSecretary, typeId: MEMBER_TYPE.THU_KY}, ...newOfficerList],
      offices: [{...values.executiveOrganization, typeId: ORG_TYPE.TO_CHUC_CHU_TRI}, ...organizationList],
      file: newFile
    }
    let formData = objectToFormData(dataTopicOutline);
    try {
      setIsLoading(true);
      let { data } = await updateTopicOutline(formData, String(state?.data?.id));
      if (CODE.SUCCESS === data?.code) {
        setIsLoading(false);
        setIsEdit(false);
        toast.success("Chỉnh sửa đề cương thành công");
        let topicId = topicInfo?.id;
        if (!topicId) return;
        let res = await getOulineFile(topicId);
        if (res?.data?.code === CODE.SUCCESS) {
          setOutlineFiles(res?.data?.data || []);
        }
      } else {
        setIsLoading(false);
        let errorMesage = data?.data?.[0]?.message ?? "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
      }
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Formik<TTopicDetails>
      enableReinitialize
      innerRef={formRef}
      initialValues={{ ...topicInfo, executiveOrganization, mainResearcher, topicSecretary, startDate: topicInfo?.startDate?.slice(0, -3), endDate: topicInfo?.endDate?.slice(0, -3) }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        handleFormSubmit(values);
        setSubmitting(false);
      }}
    >
      {() => {
        return (
          <FormikForm>
            <Modal.Body className="spaces p-0 mt-5 bg-white">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Đề cương</Accordion.Header>
                  <Accordion.Body>
                    <div className="flex flex-column gap-3 w-100">
                      {isEdit ? (
                        <Form.Group controlId="formFile" className="flex-1">
                          <Form.Control
                            type="file"
                            size="sm"
                            accept=".pdf,.doc,.docx"
                            onChange={handleChangeFile}
                          />
                        </Form.Group>
                      ) : (
                        <>
                          {outlineFiles.length > 0 ? (
                            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                              {outlineFiles.map((file) => (
                                <div
                                  key={file.id}
                                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                                  className="mb-2"
                                >
                                  <Form.Group controlId={`formFile-${file.id}`} className="flex-1">
                                    <Form.Control
                                      type="text"
                                      disabled
                                      size="sm"
                                      value={`[${file.originalName}]-[${file.latest ? 'Mới nhất' : 'Cũ'}]-[Tạo: ${moment(file.createdDate).format('DD/MM/YYYY HH:mm')}]`}
                                    />
                                  </Form.Group>
                                  <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => handleDownloadFile(file.id, file.originalName)}
                                  >
                                    Tải xuống
                                  </Button>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p>Chưa có file đề cương nào.</p>
                          )}
                        </>
                      )}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Modal.Body>
          </FormikForm>
        );
      }}
    </Formik>
  );
};
export default TabOutline;
